var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-info" },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "demo-ruleForm",
            attrs: { model: _vm.msgInfo, rules: _vm.rules }
          },
          [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("标题")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "txt" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.msgInfo.txt,
                          callback: function($$v) {
                            _vm.$set(_vm.msgInfo, "txt", $$v)
                          },
                          expression: "msgInfo.txt"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-row", staticStyle: { height: "90px" } },
              [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("内容")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "data" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.msgInfo.data,
                            callback: function($$v) {
                              _vm.$set(_vm.msgInfo, "data", $$v)
                            },
                            expression: "msgInfo.data"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isVoucher
      ? _c("div", { staticClass: "form-info" }, [
          _c("div", { staticClass: "form-row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-radio-group",
                  {
                    on: {
                      change: function($event) {
                        _vm.loadStaffList(_vm.transOrgFlag)
                      }
                    },
                    model: {
                      value: _vm.transOrgFlag,
                      callback: function($$v) {
                        _vm.transOrgFlag = $$v
                      },
                      expression: "transOrgFlag"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: true } }, [_vm._v("是")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: false } }, [_vm._v("否")])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.transOrgFlag
            ? _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: { height: "auto", overflow: "hidden" }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value flex" },
                    [
                      _c("swb-org-tree", {
                        ref: "swb_org_tree",
                        attrs: {
                          isCom: false,
                          accordion: true,
                          isShowIcon: false
                        },
                        on: {
                          "notity-change": function($event) {
                            _vm.notityChange($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value flex" },
              [
                _c("swb-com-staff-list-for-msg", {
                  ref: "swb_com_staff_list_for_msg",
                  attrs: { transOrgFlag: _vm.transOrgFlag, comId: _vm.comId }
                })
              ],
              1
            )
          ])
        ])
      : _c("div", [
          _c("div", { staticClass: "form-row" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.checkList,
                      callback: function($$v) {
                        _vm.checkList = $$v
                      },
                      expression: "checkList"
                    }
                  },
                  [
                    _c(
                      "el-checkbox",
                      { attrs: { label: "comIn", disabled: true } },
                      [_vm._v("对内")]
                    ),
                    _vm._v(" "),
                    _c("el-checkbox", { attrs: { label: "comOut" } }, [
                      _vm._v("对外")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("是否跨组织架构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v(" ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v(" ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("发送方式")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc2f183", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc2f183","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/msg/SendMsgMail.vue
// module id = 1805
// module chunks = 1